// extracted by mini-css-extract-plugin
export default {"btn-override":"Privacy_style_btn-override__6ymWW","content":"Privacy_style_content__zYK9h","rotate":"Privacy_style_rotate__cJdV0"};